import React from "react";
import { Row, Col } from "react-bootstrap";
import { number, object, string, oneOfType, bool } from "prop-types";
import { generateTables, getTypingPassage } from "./candidateResponseHelpers";

const CandidateResponseSection = ({ isTestMakerTT, testId, testScores }) => {
  const isTT = testId === "17";

  const tables = generateTables(testId, testScores, isTT, isTestMakerTT);

  const noDataMessage = (
    <div>
      <h3 className="text-center header-empty-state">
        There are no candidate responses to display.
      </h3>
    </div>
  );

  return (
    <Col className="py-3">
      {isTT && getTypingPassage()}
      <h2 className="score-detail-section-heading">
        Candidate Response{!(isTT || isTestMakerTT) && "s"}
      </h2>
      <Row>{tables || noDataMessage}</Row>
    </Col>
  );
};

CandidateResponseSection.propTypes = {
  isTestMakerTT: bool,
  testId: oneOfType([number, string]),
  testScores: object,
};

export default CandidateResponseSection;
